
import { Alert } from "@heroui/react";
import { useNavigate } from "react-router-dom";

const Error = () => {

    const navigate = useNavigate();

    return (
        <div className="flex flex-col h-full items-center justify-center space-y-8">
            <Alert color="danger" className="grow-0 w-auto rounded-none" variant="solid">
                <p className="text-md">There was an error processing your request. Try refreshing the page or contact MSI.</p>
            </Alert>
            <a className="w-auto navigate-link" onClick={(e) => { e.preventDefault(); navigate('/product-selection') }} >Refresh</a>
            <a className="w-auto navigate-link" href={`${window.config.MAIN_WEBSITE_URL}`} >Return to main website</a>
        </div>


    );
}



export default Error;